<template>
    <div class="pt-3 pb-3">
        <vue-element-loading :active="show" spinner="ring" color="#006db3" size="128" text="กรุณารอสักครู่..." is-full-screen/>
        
    </div>
</template>

<script>
import Vue from 'vue';
import Api from './../api';
export default {
    components: {
        
    },
    
    data() {
        return {
            show: false,
        };
    },

    created(){
        this.getTest();
    },

    methods: {
        getTest(){
            this.show = true;
            Api.getTest().then(res => {
                this.show = false;
                var {data} = res;
                console.log(data)
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },
    }
};
</script>

<style scoped>
</style>